<template>
  <div>
    <b-row>
      <b-col cols="6">
        <b-form-group label="Data inicial:">
          <b-form-input
            type="date"
            v-model="params.dateInitialFilterComments"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col cols="6">
        <b-form-group label="Data final:">
          <b-form-input
            id="input-date-2"
            type="date"
            v-model="params.dateFinalFilterComments"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <div>
          <span class="label-status">Status:</span>
          <v-select
            class="mt-1"
            v-model="params.status"
            :options="optionsStatus"
            multiple
          ></v-select>
        </div>
      </b-col>
    </b-row>

    <hr />
    <div
      id="table-comment"
      style="height: calc(100vh - 445px); overflow: auto; position: relative"
    >
      <table class="table table-hover table-sm small table-borderless">
        <thead>
          <tr>
            <th style="width: 50px" class="th-order text-center">ID</th>
            <th style="width: 80px" class="th-order text-start">Nome</th>
            <th style="width: 200px" class="th-order text-start">Descrição</th>
            <th style="width: 50px" class="th-order text-center">Data/Hora</th>
            <th style="width: 80px" class="th-order text-center">Status</th>
            <th style="width: 30px" scope="col" aria-label="btn-actions"></th>
          </tr>
          <tr class="border-top border-bottom">
            <th style="width: 50px">
              <TableSearch
                :value="params.id"
                @input="params.id = $event"
                styleSearch="width: 50px"
              />
            </th>
            <th style="width: 80px">
              <TableSearch
                :value="params.name"
                @input="params.name = $event"
                styleSearch="width: 150px"
              />
            </th>
            <th style="width: 200px">
              <TableSearch
                :value="params.description"
                @input="params.description = $event"
                styleSearch="width: 130px"
              />
            </th>
            <td
              style="width: 80px"
              class="search-group ng-star-inserted d-print-none"
            ></td>
            <td
              style="width: 80px"
              class="search-group ng-star-inserted d-print-none"
            ></td>
            <td
              style="width: 30px"
              class="search-group ng-star-inserted d-print-none"
            ></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="comment in comments" :key="comment.id">
            <th style="width: 50px" class="th-order text-center">
              {{ comment.id }}
            </th>
            <th style="width: 80px" class="th-order text-start">
              {{ comment.name }}
            </th>
            <th
              style="width: 200px"
              class="th-order text-start hide-text-break"
            >
              {{ comment.description }}
            </th>
            <th style="width: 50px" class="th-order text-center">
              {{ comment.dateRegisterFormatted }}
            </th>
            <th style="width: 80px" class="th-order text-center">
              {{ comment.status }}
            </th>
            <th style="width: 30px" class="th-order text-center">
              <div
                style="cursor: pointer"
                v-b-modal.approved-comment
                @click="commentSelected = comment"
                class="mr-2"
              >
                <svg
                  style="font-size: 1.3rem"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="edit"
                  class="svg-inline--fa fa-edit fa-w-18 text-success"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path
                    fill="currentColor"
                    d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
                  ></path>
                </svg>
              </div>
            </th>
          </tr>
        </tbody>
      </table>
      <div v-show="progress" class="text-center">
        <p>Carregando...</p>
        <b-spinner variant="dark" label="Loading..."></b-spinner>
      </div>
      <CommentApprovalModal
        @updateComment="updateComment"
        :comment="commentSelected"
      />
    </div>
    <TableFooter
      :lengthElements="lengthElements"
      :totalElements="totalElements"
    />
  </div>
</template>

<script>
import TableSearch from "../TableSearch.vue";
import TableFooter from "../TableFooter.vue";
import CommentApprovalModal from "./CommentApprovalModal.vue";
import { baseApiUrl } from "@/global";
import axios from "axios";
import Qs from "qs";
import { formatDateTime } from "@/config/util";

export default {
  components: { TableSearch, TableFooter, CommentApprovalModal },
  data: function () {
    return {
      page: 0,
      lastSearch: {},
      commentSelected: {},
      optionsStatus: ["ABERTO", "APROVADO", "RECUSADO"],
      progress: false,
      params: {
        id: "",
        name: "",
        description: "",
        dateInitialFilterComments: "",
        dateFinalFilterComments: "",
        status: ["ABERTO"],
      },
      comments: [],
    };
  },
  watch: {
    params: {
      handler(newValue) {
        this.loadComments(true, newValue);
      },
      deep: true,
    },
  },
  computed: {
    lengthElements() {
      return this.comments.length;
    },
    totalElements() {
      return this.lastSearch.totalElements;
    },
  },
  methods: {
    setParams(attribute, newValue) {
      this.params[attribute] = newValue;
    },
    loadComments(isFistPage, paramsFilter) {
      this.progress = true;
      const url = `${baseApiUrl}/api/comentarios/filtro`;
      if (isFistPage) {
        this.page = 0;
        this.comments = [];
      }
      axios
        .get(url, {
          params: {
            ...paramsFilter,
            size: 20,
          },
          paramsSerializer: (params) =>
            Qs.stringify(params, { arrayFormat: "repeat" }),
        })
        .then((res) => {
          this.progress = false;
          this.comments = [
            ...this.comments,
            ...res.data.content.map((comment) => {
              return {
                ...comment,
                dateRegisterFormatted: formatDateTime(comment.dateRegister),
              };
            }),
          ];
          this.lastSearch = { ...res.data };
          this.page++;
          this.isFistPage = false;
        });
    },
    updateComment(eventCommentUpdated) {
      this.comments = this.comments.map((c) => {
        if (c.id === eventCommentUpdated.id) {
          return {
            ...eventCommentUpdated,
            dateRegisterFormatted: formatDateTime(eventCommentUpdated.dateRegister)
          };
        }
        return c;
      });
    },
  },
  mounted() {
    this.loadComments(true, this.params);
    const listElm = document.querySelector("#table-comment");
    listElm.addEventListener("scroll", () => {
      if (
        listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight &&
        !this.lastSearch.empty
      ) {
        this.loadComments(false, {
          ...this.params,
          page: (this.lastSearch.number += 1),
        });
      }
    });
  },
};
</script>


<style>
.hide-text-break {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 200px;
}

.content-status {
  width: 100%;
}

.label-status {
  font-size: 0.8rem;
}

.content-status > .multiselect > .multiselect__tags {
  min-height: 40px;
  display: block;
  padding: 8px 40px 0 8px;
  border-radius: 5px;
  border: 2px solid #e6e6e6;
  background: #fff;
  font-size: 14px;
}

.content-status
  > .multiselect
  > .multiselect__tags
  > .multiselect__tags-wrap
  > .multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #000;
  line-height: 1;
  background: #e6e6e6;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}

.content-status
  > .multiselect
  > .multiselect__tags
  > .multiselect__tags-wrap
  > .multiselect__tag
  > .multiselect__tag-icon::after {
  color: #000;
}

.content-status
  > .multiselect
  > .multiselect__tags
  > .multiselect__tags-wrap
  > .multiselect__tag:hover
  > .multiselect__tag-icon::after {
  color: #fff;
}

.content-status
  > .multiselect
  > .multiselect__tags
  > .multiselect__tags-wrap
  > .multiselect__tag:hover
  > .multiselect__tag-icon:hover {
  background: #ececec;
  content: "\D7";
  color: #ececec;
  font-size: 14px;
}

.content-status
  > .multiselect
  > .multiselect__content-wrapper
  > .multiselect__content
  > .multiselect__element
  > .multiselect__option--highlight {
  background: #ececec;
}

.content-status
  > .multiselect
  > .multiselect__content-wrapper
  > .multiselect__content
  > .multiselect__element
  > .multiselect__option--highlight::after {
  background: #ececec;
  color: #000;
}

.content-status
  > .multiselect
  > .multiselect__content-wrapper
  > .multiselect__content
  > .multiselect__element
  > .multiselect__option--selected.multiselect__option--highlight {
  background: #ececec;
}

.content-status
  > .multiselect
  > .multiselect__content-wrapper
  > .multiselect__content
  > .multiselect__element
  > .multiselect__option--selected.multiselect__option--highlight::after {
  background: #ececec;
  color: #000;
}
</style>